import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";

// Components
import Header from "./components/Header";
import Footer from "./components/Footer";
import FloatingWhatsApp from "./components/FloatingWhatsApp";

// Public Pages
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ServicesPage from "./pages/ServicesPage";
import ProductsPage from "./pages/ProductsPage";
import ContactPage from "./pages/ContactPage";
import FAQPage from "./pages/FAQPage";

// Admin Pages
import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminSettings from "./pages/admin/AdminSettings";
import AdminServices from "./pages/admin/AdminServices";
import AdminProducts from "./pages/admin/AdminProducts";
import AdminFAQs from "./pages/admin/AdminFAQs";
import AdminImages from "./pages/admin/AdminImages";
import AdminPages from "./pages/admin/AdminPages";

// Public Layout wrapper
const PublicLayout = ({ children }) => (
  <>
    <Header />
    <main className="flex-1">{children}</main>
    <Footer />
    <FloatingWhatsApp />
  </>
);

function App() {
  return (
    <div className="App min-h-screen flex flex-col">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<PublicLayout><HomePage /></PublicLayout>} />
            <Route path="/hakkimizda" element={<PublicLayout><AboutPage /></PublicLayout>} />
            <Route path="/hizmetlerimiz" element={<PublicLayout><ServicesPage /></PublicLayout>} />
            <Route path="/satin-aldigimiz-esyalar" element={<PublicLayout><ProductsPage /></PublicLayout>} />
            <Route path="/iletisim" element={<PublicLayout><ContactPage /></PublicLayout>} />
            <Route path="/sss" element={<PublicLayout><FAQPage /></PublicLayout>} />

            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="dashboard" element={<AdminDashboard />} />
              <Route path="settings" element={<AdminSettings />} />
              <Route path="pages" element={<AdminPages />} />
              <Route path="services" element={<AdminServices />} />
              <Route path="products" element={<AdminProducts />} />
              <Route path="faqs" element={<AdminFAQs />} />
              <Route path="images" element={<AdminImages />} />
            </Route>
          </Routes>
          <Toaster position="top-right" />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
